import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { setAuthToken, getAuthToken, decodeToken } from './token';
export const AuthCallback = ({ redirectTo = '/dashboard', loginPath = '/login', }) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    useEffect(() => {
        const token = searchParams.get('token');
        console.log('[AuthCallback] iniciando. token en URL:', !!token, '| redirectTo:', redirectTo, '| loginPath:', loginPath);
        if (token) {
            const decoded = decodeToken(token);
            console.log('[AuthCallback] token decodificado:', decoded
                ? {
                    app_type: decoded.app_type,
                    company_id: decoded.company_id,
                    user_id: decoded.user_id,
                    must_change_password: decoded.must_change_password,
                    created_from_vendedor: decoded.created_from_vendedor,
                    needs_onboarding: decoded.needs_onboarding,
                    exp_human: new Date((decoded.exp || 0) * 1000).toISOString(),
                }
                : 'null (token inválido)');
            if (!decoded || !decoded.exp || decoded.exp < Date.now() / 1000) {
                console.warn('[AuthCallback] token inválido o expirado → navigate a loginPath:', loginPath);
                navigate(loginPath, { replace: true });
                return;
            }
            setAuthToken(token);
            console.log('[AuthCallback] token guardado en localStorage → hard reload a redirectTo:', redirectTo);
            // Recarga COMPLETA (no client-side) para que los providers (CompanyConfig, etc.)
            // monten con el token ya en localStorage y carguen su config en el primer render.
            // Con navigate() del lado cliente, el provider ya había ejecutado su carga única
            // SIN token (al montar en /auth-callback), y la config no se cargaba hasta que el
            // usuario recargaba a mano (síntoma: sidebar/billing en estado por defecto al loguear).
            window.location.replace(redirectTo);
        }
        else {
            console.warn('[AuthCallback] sin token en URL → revisando localStorage...');
            // No token in URL — check localStorage for an existing valid token
            const existing = getAuthToken();
            if (existing) {
                const payload = decodeToken(existing);
                const now = Math.floor(Date.now() / 1000);
                if (payload && payload.exp && payload.exp > now) {
                    console.log('[AuthCallback] token existente válido en localStorage → navigate a redirectTo:', redirectTo);
                    navigate(redirectTo, { replace: true });
                    return;
                }
                console.warn('[AuthCallback] token en localStorage expirado o inválido');
            }
            else {
                console.warn('[AuthCallback] sin token en localStorage');
            }
            console.warn('[AuthCallback] → navigate a loginPath:', loginPath);
            navigate(loginPath, { replace: true });
        }
    }, [navigate, searchParams, redirectTo, loginPath]);
    return (_jsx("div", { style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
        }, children: _jsx("div", { children: "Loading..." }) }));
};
